import { Button } from '@app/components/various/Button';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';

interface Props {
  acceptAction: () => void;
  discardAction?: () => void;
  testId?: string;
}

export const AcceptDiscard = ({ acceptAction, discardAction, testId = 'closeToolbar' }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div className="flex">
      {isDefined(discardAction) && (
        <Button onClick={discardAction} color="secondary" variant="ghost">
          {t('common:cancel')}
        </Button>
      )}
      <Button onClick={acceptAction} variant="ghost" color="secondary" dataTestId={testId}>
        {t('common:apply')}
      </Button>
    </div>
  );
};
